import { Text } from "../../../foundations/palette.es.js";
import { styled } from "@mui/material";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Typography } from "../../typography/typography.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
const QuantitySelectorContainer = styled("div")({
  display: Displaying.flex,
  alignItems: Alignment.center
});
const quantitySelectorLetterSpacing = "0.009375rem";
const QuantitySelectorTypographyContainer = styled(Typography)({
  fontStyle: "normal",
  fontSize: Spacing["1000"],
  letterSpacing: quantitySelectorLetterSpacing,
  color: Text.primary,
  lineHeight: "150%"
});
const TypographyWrapperContainer = styled("div")({
  padding: `0 ${Spacing["250"]}`
});
export {
  QuantitySelectorContainer,
  QuantitySelectorTypographyContainer,
  TypographyWrapperContainer
};
//# sourceMappingURL=container.es.js.map
